/**
 * 权限控制配置
 * 
 * 权限规则：
 * - '*' 表示超级管理员，拥有所有权限
 * - 其他权限按功能模块细分
 * 
 * 权限列表：
 * - dashboard:view - 查看数据概览
 * - user:read - 查看用户
 * - user:ban - 封禁用户
 * - user:recharge - 用户充值
 * - finance:read - 查看财务
 * - finance:export - 导出财务
 * - config:read - 查看模型配置
 * - config:write - 修改模型配置
 * - system:config - 系统配置
 * - system:announcement - 公告管理
 * - system:admin - 管理员管理
 * - system:role - 角色管理
 */

export default function access(initialState) {
  const { currentUser } = initialState || {};
  const permissions = currentUser?.permissions || [];
  const isSuperAdmin = permissions.includes('*');

  return {
    // 超级管理员
    canAdmin: isSuperAdmin,
    
    // 数据概览
    canViewDashboard: isSuperAdmin || permissions.includes('dashboard:view'),
    
    // 用户管理
    canViewUser: isSuperAdmin || permissions.includes('user:read'),
    canBanUser: isSuperAdmin || permissions.includes('user:ban'),
    canRechargeUser: isSuperAdmin || permissions.includes('user:recharge'),
    
    // 财务管理
    canViewFinance: isSuperAdmin || permissions.includes('finance:read'),
    canExportFinance: isSuperAdmin || permissions.includes('finance:export'),
    
    // 模型管理
    canViewModel: isSuperAdmin || permissions.includes('config:read'),
    canManageModel: isSuperAdmin || permissions.includes('config:write'),
    
    // 计费管理
    canManageBilling: isSuperAdmin || permissions.includes('system:config'),
    
    // 系统管理 - 细分权限
    canManageSystem: isSuperAdmin,  // 系统配置（超级管理员专属）
    canManageStorage: isSuperAdmin || permissions.includes('system:config'),
    canManagePayment: isSuperAdmin || permissions.includes('system:config'),
    canManageSMS: isSuperAdmin || permissions.includes('system:config'),
    canManageAnnouncement: isSuperAdmin || permissions.includes('system:announcement'),
    canManageAdmin: isSuperAdmin || permissions.includes('system:admin'),
    canManageRole: isSuperAdmin || permissions.includes('system:role'),
  };
}
